import { useEffect, useRef } from "react";
import { useTheme } from "../../components/Layout/ThemeContext/ThemeContext";
import "react-tooltip/dist/react-tooltip.css";
import { useAuth } from "../../Providers/AuthProvider/AuthProvider";
import config from '../../components/Common/config'; // Import your config file
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";

const loadAttachments = async () => {
  const API_URL = "https://isthydpc55.istindia.com:7265/api/Registration/media";

  try {
    //const response = await fetch(API_URL);
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Registration/media`, {
      method: 'GET', // or any other method like POST if needed
      headers: {
          'Content-Type': 'application/json', // Optionally specify content type
      }
  });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data)) {
      const allMediaItems = data.map((mediaItem) => ({
        type: mediaItem.contenT_TYPE,  // Assuming API response has `contentType`
        url: mediaItem.fileUrl,       // Assuming API response has `fileUrl`
        objectId: mediaItem.attachmentid || "", // Assuming API response has `objectId`
        layerName: mediaItem.layerName || "Unknown Layer",
        addPOIName: mediaItem.addPOIName || "Unknown POI",
        REL_GLOBALID: mediaItem.reL_GLOBALID
      }));

      return { Media: allMediaItems, status: true };
    }

    return { Media: [], status: false };
  } catch (error) {
    console.error("Error fetching media from API:", error);
    return { Media: [], status: false };
  }
};

export default loadAttachments;

